import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

/**
 * Shared Markdown renderer. Styled to match the terminal editing aesthetic.
 * Content is now driven from .md files via loadContent.js.
 */
const MarkdownRenderer = ({ children }) => (
  <div className="markdown">
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw]}
      components={{
        // Add stable id attributes so the section nav can scroll to them.
        h2: ({ children, ...props }) => {
          const text = extractText(children);
          const id = text
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, "-")
            .replace(/^-+|-+$/g, "");
          return (
            <h2 id={id} {...props}>
              {children}
            </h2>
          );
        },
      }}
    >
      {children}
    </ReactMarkdown>
  </div>
);

/** Extract plain text from React children (strings, numbers, arrays). */
function extractText(node) {
  if (typeof node === "string") return node;
  if (typeof node === "number") return String(node);
  if (Array.isArray(node)) return node.map(extractText).join("");
  // React element — recurse into its children
  if (node?.props?.children) return extractText(node.props.children);
  return "";
}

export default MarkdownRenderer;